// ──────────────────────────────────────────────────────────────────────
// Supabase client — env-gated.
//
// If REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY is not set,
// `supabase` exports as null and `supabaseEnabled` is false. The app
// then shows the sign-in screen only (there is no code or admin fallback).
//
// ──────────────────────────────────────────────────────────────────────

import { createClient } from '@supabase/supabase-js';
import { syncSessionCookie } from './sessionCookie';

const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseEnabled =
  !!(SUPABASE_URL && SUPABASE_ANON &&
     SUPABASE_URL.startsWith('https://') && SUPABASE_ANON.length > 20);

export const supabase = supabaseEnabled
  ? createClient(SUPABASE_URL, SUPABASE_ANON, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true, // for password-reset / magic-link redirects
      },
    })
  : null;

// The content gate (proxy.js) reads the session from a cookie, since a lesson page loading in an iframe cannot
// send what is in localStorage: keep the cookie in step with the session, on sign-in, every refresh and sign-out.
if (supabase) {
  supabase.auth.getSession().then(({ data }) => syncSessionCookie(data?.session || null)).catch(() => {});
  supabase.auth.onAuthStateChange((_event, session) => syncSessionCookie(session || null));
}
